/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

const FOLDER = 'folder',
  STANDARD = 'standard',
  FRAME = 'frame',
  SKIP_USER_INPUT = 'skip_user_input',
  CONVERSATION_START = 'conversation_start',
  ANYTHING_ELSE = 'anything_else',
  JUMP_TO = 'jump_to';

//types: standard, event_handler, frame, slot, response_condition, folder
const RELEVANT_NODE_TYPES = [STANDARD, FRAME];
const IGNORE_CONDITIONS = [CONVERSATION_START, ANYTHING_ELSE];

function flatten(arrOfArr) {
  return arrOfArr.reduce((acc, arr) => acc.concat(arr), []);
}

function distinct(arr) {
  return arr.filter((x, i, arr) => arr.indexOf(x) === i);
}

function siblings(node, allNodes) {
  const sibling = allNodes.find(
    aNode => aNode.previous_sibling === node.dialog_node
  );
  if (sibling) {
    return [sibling, ...siblings(sibling, allNodes)];
  }
  return [];
}

function walk(node, allNodes, visited) {
  if (visited.includes(node)) {
    return [];
  }
  visited.push(node);
  if (IGNORE_CONDITIONS.includes(node.conditions)) {
    return [];
  }
  if (
    node.type === FOLDER ||
    (node.next_step && node.next_step.behavior === SKIP_USER_INPUT)
  ) {
    const children = allNodes.filter(n => n.parent === node.dialog_node);
    return flatten(children.map(n => walk(n, allNodes, visited)));
  }
  if (node.next_step && node.next_step.behavior === JUMP_TO) {
    const trg = allNodes.find(
      n => n.dialog_node === node.next_step.dialog_node
    );
    const trgAndSiblings = [trg, ...siblings(trg, allNodes)];
    return flatten(trgAndSiblings.map(n => walk(n, allNodes, visited)));
  }
  if (RELEVANT_NODE_TYPES.includes(node.type)) {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 3 arguments, but got 2.
    const topNode = getTopNode(node, allNodes);
    if (node.user_label || !topNode.user_label) {
      return [node];
    }
    return [topNode];
  }
  return [];
}

function getTopNode(node, allNodes, top) {
  if (!node.parent) {
    //root level
    if (node.type === FOLDER) {
      return top;
    }
    return node;
  }
  const parent = allNodes.find(n => n.dialog_node === node.parent);
  if (node.type === FOLDER) {
    return getTopNode(parent, allNodes, top);
  }
  return getTopNode(parent, allNodes, node);
}

export const filterUserLabels = allNodes => {
  const topNodes = allNodes.filter(n => !n.parent);
  const visited = [];
  const nodes = distinct(
    flatten(topNodes.map(n => walk(n, allNodes, visited)))
  );
  return nodes;
};
